import Auth from '@/infrastructure/api/helper/Auth';
import Client from '@/infrastructure/api/helper/Client';

import {APIバージョン情報型} from '@/type/version/version';
import {トークン型, 代行ログイントークン型, 認証型} from '@/type/authentication/authentication';
import {ログインアカウント型} from '@/type/authentication/login';

import {
  HTデータ取込対象一覧取得結果型,
  ハンディPC発注取得依頼型,
  ハンディPC発注取得結果一覧型,
  ハンディPC発注取込型,
  ハンディPC発注取込結果型,
  優先卸変更依頼型,
  商品追加候補検索条件型,
  商品追加検索結果一覧型,
  定点発注検索条件型,
  定点発注検索結果一覧型,
  履歴追加候補検索条件型,
  履歴追加検索結果一覧型,
  コード入力候補検索条件型,
  コード入力検索結果一覧型,
  発注未確定一覧取得依頼型,
  発注未確定一覧取得結果型,
  発注未確定削除依頼型,
  発注未確定更新型,
  発注未確定登録型,
  発注未確定登録結果型,
  発注確定送信型,
  発注確定送信結果型,
  過去発注情報取得結果型,
} from '@/type/purchaseorder/item';
import {発注履歴照会依頼型, 発注履歴照会型, 発注履歴照会結果型} from '@/type/purchaseorder/history';
import {棚卸差数在庫場所結果型, 棚卸差数棚卸年月日型, 棚卸差数検索依頼型, 棚卸差数結果型} from '@/type/inquire/item';
import {定点発注条件設定取得依頼型, 定点発注条件設定取得結果一覧型, 定点発注条件設定取込不可一覧型, 定点発注条件設定更新依頼型} from '@/type/automatedorder/item';
import {入庫履歴照会依頼型, 入庫履歴照会型, 入庫履歴照会結果型} from '@/type/stock/receive/hisotry';
import {返品履歴照会依頼型, 返品履歴照会型} from '@/type/stock/returns/hisotry';
import {納品データ受信依頼型, 納品データ受信型, 納品伝票型, 納品伝票明細一覧取得依頼型, 納品伝票明細型, 納品データ受信結果型} from '@/type/stock/deliverydata/deliverydata';
import {未入庫納品伝票明細型, 納品データ検索依頼型, 未入庫納品データ検索結果型} from '@/type/stock/deliverydata/unstocked_deliverydata';
import {初期卸型, 採用品包括型, 採用品型, 採用品拡張項目型, 採用品検索条件型, 採用品検索結果型, 採用品管理対象外識別子型} from '@/type/master/item';
import {商品卸型} from '@/type/master/item/wholesale';
import {価格履歴型} from '@/type/master/item/price';
import {医薬品型, 医薬品検索結果型, 薬効型} from '@/type/master/item/medicine';
import {医薬品検索条件型} from '@/type/master/item/medicine/condition';
import {メーカー検索条件型, メーカー検索結果型} from '@/type/master/item/maker';
import {その他品型, その他品検索結果型} from '@/type/master/item/other';
import {備蓄品型, 備蓄品検索結果型} from '@/type/master/item/stockpile';
import {商品別連携設定一括登録結果型, 商品別連携設定検索条件型, 商品別連携設定登録型, 商品別連携設定検索結果型} from '@/type/master/item/external';
import {採用品Excel出力設定型} from '@/type/master/item/exportconfig';
import {
  優先卸個別変更依頼型,
  入札商品検索条件型,
  入札確定依頼型,
  入札開始依頼型,
  入札額変更依頼型,
  卸比較優先卸変更依頼型,
  卸比較優先卸変更結果型,
  卸比較商品型,
  未確定入札削除依頼型,
  未確定入札取得依頼型,
  確定済入札削除依頼型,
  入札Excel取込結果型,
  入札商品検索結果型,
} from '@/type/estimates/comparison';
import {
  入札取込結果型,
  遡及引当削除依頼型,
  遡及引当型,
  遡及引当履歴型,
  遡及引当更新依頼型,
  遡及引当検索依頼型,
  遡及検索条件型,
  遡及訂正登録依頼型,
  遡及引当検索結果型,
} from '@/type/retrospective/retrospective';
import {発注状況一覧取得依頼型, 発注状況型, 発注状況更新依頼型, 発注状況一覧取得結果型} from '@/type/purchaseorder/status';
import {非稼働日一覧取得依頼型, 非稼働日一覧取得結果型} from '@/type/calendar/non-operation';
import {バーコードブック取込結果型} from '@/type/barcodebook/item';
import {利用者型} from '@/type/user/user';
import {部署型} from '@/type/department/department';
import {EOS卸型, 卸型} from '@/type/wholesale/wholesale';
import {譲渡譲受医療機関削除依頼型, 譲渡譲受医療機関型} from '@/type/transfermedical/transferMedical';
import {確定送信者型} from '@/type/user/sender';
import {入庫返品薬価差明細型, 入庫返品薬価差集計結果型, 入庫返品薬価差集計依頼型} from '@/type/stock/receive/price_diff';
import {棚番設定取得結果型, 棚番設定更新型, 棚番設定表示条件型, 棚番設定取込不可一覧型, 棚番設定一覧取得結果返却型} from '@/type/shelf/settings';
import {入庫作成依頼型, 入庫候補商品型, 入庫候補検索条件型, 入庫候補検索結果型, コード入力入庫候補検索条件型, コード入力入庫候補検索結果型} from '@/type/stock/receive/item';
import {在庫指定返品作成依頼型, 返品候補在庫型, 返品候補在庫検索条件型, 返品候補在庫検索結果型} from '@/type/stock/returns/stock';
import {入庫指定返品作成依頼型, 返品候補入庫型, 返品候補入庫検索条件型, 返品候補入庫検索結果型} from '@/type/stock/returns/receive';
import {
  ハンディ返品レコード型,
  ハンディ返品取込依頼型,
  ハンディ返品検索依頼型,
  未確定返品一覧取得依頼型,
  未確定返品取込依頼型,
  返品入力型,
  返品確定依頼型,
  返品納品データ取込依頼型,
  返品納品データ取込結果型,
} from '@/type/stock/returns/unfixed';
import {確定済返品検索条件型, 返品修正依頼型, 返品修正削除レコード型, 確定済返品検索結果型} from '@/type/stock/returns/fixed';
import {入庫修正削除依頼型, 入庫修正削除型, 確定済在庫検索条件型, 確定済在庫検索結果型} from '@/type/stock/receive/fixed';
import {
  ハンディ入庫レコード型,
  ハンディ入庫取込依頼型,
  ハンディ入庫検索依頼型,
  入庫保存依頼型,
  入庫入力型, 入庫取込依頼型,
  入庫確定依頼型,
  入庫納品データ検索条件型,
  入庫納品データ検索結果型,
  未確定入庫一覧取得依頼型,
} from '@/type/stock/receive/unfixed';
import {発注指定入庫確定依頼型} from '@/type/stock/receive/order';
import {譲受候補作成依頼型, 譲受候補商品型, 譲受候補検索条件型, 譲受候補検索結果型} from '@/type/stock/inherit/search/item';
import {譲受候補入力型, 譲受確定依頼型, 譲受金額算出依頼型, 譲受金額算出結果型} from '@/type/stock/inherit/input/item';
import {譲受修正依頼型, 譲受修正検索結果型, 譲受削除依頼型, 譲受検索条件型} from '@/type/stock/inherit/modification/item';
import {譲受履歴レコード型, 譲受履歴検索条件型, 譲受履歴検索結果型} from '@/type/stock/inherit/history/item';
import {商品指定譲渡候補作成依頼型, 商品指定譲渡候補型, 譲渡候補商品検索条件型, 譲渡候補商品検索結果型} from '@/type/stock/devolve/search/item';
import {在庫指定譲渡候補作成依頼型, 在庫指定譲渡候補型, 譲渡候補在庫検索条件型, 譲渡候補在庫検索結果型} from '@/type/stock/devolve/search/expiration';
import {譲渡候補入力型, 譲渡確定依頼型, 譲渡確定結果型, 譲渡確認消費税型, 譲渡金額算出依頼型, 譲渡金額算出結果型} from '@/type/stock/devolve/input/item';
import {譲渡修正依頼型, 譲渡修正検索結果型, 譲渡削除依頼型, 譲渡検索条件型} from '@/type/stock/devolve/modification/item';
import {譲渡履歴レコード型, 譲渡履歴検索条件型, 譲渡履歴検索結果型} from '@/type/stock/devolve/history/item';
import {優先卸予約削除依頼型, 優先卸予約登録依頼型, 優先卸取込結果型, 優先卸検索結果型, 優先卸履歴型, 優先卸更新依頼型, 優先卸検索依頼型} from '@/type/wholesale/primary/wholesale';
import {破棄破損依頼型} from '@/type/destroy/records/register/破棄破損依頼型';
import {破棄破損候補検索条件型} from '@/type/destroy/records/register/破棄破損候補検索条件型';
import {破棄破損候補検索結果レコード型, 破棄破損候補検索結果型} from '@/type/destroy/records/register/破棄破損候補検索結果レコード型';
import {破棄破損修正候補検索条件型} from '@/type/destroy/records/modify/破棄破損修正候補検索条件型';
import {破棄破損修正候補検索結果レコード型, 破棄破損修正候補検索結果型} from '@/type/destroy/records/modify/破棄破損修正候補検索結果レコード型';
import {破棄破損修正依頼一覧型} from '@/type/destroy/records/modify/破棄破損修正依頼型';
import {破棄破損削除依頼型} from '@/type/destroy/records/modify/破棄破損削除依頼型';
import {破棄破損履歴検索条件型} from '@/type/destroy/records/history/破棄破損履歴検索条件型';
import {払出履歴検索条件型} from '@/type/withdrawal/records/history/払出履歴検索条件型';
import {払出依頼型} from '@/type/withdrawal/records/register/払出依頼型';
import {
  ハンディ棚卸情報型,
  棚卸作成依頼型,
  棚卸保存依頼型,
  棚卸再計算依頼型,
  棚卸取得依頼型,
  棚卸情報型,
  棚卸確定依頼型,
  棚卸絞込み依頼型,
  棚卸部署型,
  棚卸部署概要型,
  棚卸部署確定取消候補型,
} from '@/type/stocktaking/types';
import {在庫場所型, 在庫照会検索条件型, 在庫照会結果型} from '@/type/refstock/item';
import {破棄破損履歴検索結果型, 破棄破損履歴検索結果返却型} from '@/type/destroy/records/history/破棄破損履歴検索結果型';
import {払出履歴検索結果型, 払出履歴検索結果返却型} from '@/type/withdrawal/records/history/払出履歴検索結果型';
import {品目別入出庫表示依頼型, 品目別入出庫集計型, 卸別入出庫集計依頼型, 卸別入出庫集計型, 卸別入出庫集計結果型} from '@/type/stock/summary/receive_delivery_summary';
import {
  現在適用価格登録依頼型,
  適用価格予約削除依頼型,
  適用価格予約登録依頼型,
  適用価格取込結果型,
  適用価格型,
  適用価格履歴型,
  適用価格更新依頼型,
  適用価格検索依頼型,
  適用価格検索結果型,
} from '@/type/item/price';
import {譲渡譲受医療機関登録依頼型} from '@/type/transfermedical/register';
import {入札商品型, 入札型, 遡及検索結果型} from '@/type/estimates/bid';
import {不動在庫明細型, 不動在庫検索依頼型, 不動在庫検索結果型} from '@/type/inactive/stock';
import {商品台帳在庫場所型, 商品台帳明細内容取得依頼型, 商品台帳明細内容型, 商品台帳鏡情報取得依頼型, 商品台帳鏡情報型} from '@/type/stock/itemledger/types';
import {マニュアル型} from '@/type/manual/manual';
import {払出候補検索結果レコード型, 払出候補検索結果型} from '@/type/withdrawal/records/register/払出候補検索結果レコード型';
import {払出候補検索条件型} from '@/type/withdrawal/records/register/払出候補検索条件型';
import {払出修正候補検索条件型} from '@/type/withdrawal/records/modify/払出修正候補検索条件型';
import {払出修正候補検索結果レコード型, 払出修正候補検索結果型} from '@/type/withdrawal/records/modify/払出修正候補検索結果レコード型';
import {払出修正依頼型} from '@/type/withdrawal/records/modify/払出修正依頼型';
import {払出削除依頼型} from '@/type/withdrawal/records/modify/払出削除依頼型';
import {院内総在庫場所型, 院内総在庫照会検索条件型, 院内総在庫照会結果型} from '@/type/stock/inhospital/item';
import {経過措置照会在庫場所型, 経過措置照会検索条件型, 経過措置照会結果型} from '@/type/stock/interim/item';
import {入出庫照会依頼型, 入出庫照会在庫場所型, 入出庫照会結果型} from '@/type/stock/receiveandreturns/types';
import {不動日数設定出力型, 不動日数設定型, 不動日数設定更新依頼型, 不動日数設定検索依頼型} from '@/type/stock/immovable/不動日数設定';
import {医療機関グループ型, 医療機関グループ詳細型, 医療機関グループ詳細検索結果型, 医療機関グループ詳細検索依頼型} from '@/type/medical/group';
import {渓仁会納品データ型, 渓仁会納品データ検索依頼型, 渓仁会納品データ検索結果型} from '@/type/custom/keijinkai/deliverydata';
import {渓仁会部署別在庫集計型, 渓仁会部署別在庫集計検索依頼型, 渓仁会部署別在庫集計検索結果型} from '@/type/custom/keijinkai/totalstock';
import {入庫候補発注補検索結果レコード型, 入庫候補発注検索条件型, 入庫候補発注検索結果型} from '@/type/stock/receive/order';
import {独自区分型} from '@/type/medical/customize';
import {渓仁会入出庫集計型, 渓仁会入出庫集計検索依頼型} from '@/type/custom/keijinkai/receiveandreturns';
import {渓仁会部署別出庫実績集計型, 渓仁会部署別出庫実績集計検索依頼型} from '@/type/custom/keijinkai/shipment';
import {
  カスタマイズ棚番設定削除依頼型,
  カスタマイズ棚番設定取得結果一覧型,
  カスタマイズ棚番設定取込不可一覧型,
  カスタマイズ棚番設定更新型,
  カスタマイズ棚番設定表示条件型,
} from '@/type/custom/goryoukaku/棚番設定';
import {発注書出力条件型, 発注書検索条件型, 発注書検索結果型} from '@/type/purchaseorder/report';

export default {

  async getApiVersion(): Promise<APIバージョン情報型> {
    const client = new Client();
    const response = await client.get('/api/version');
    const APIバージョン情報: APIバージョン情報型 = response.data;
    return APIバージョン情報;
  },

  async authenticate(認証: 認証型): Promise<トークン型> {
    const client = new Client();
    const response = await client.post('/api/authenticate', 認証);
    const トークン: トークン型 = response.data;
    return トークン;
  },

  async authenticateMasterAccount(代行ログイントークン: 代行ログイントークン型): Promise<トークン型> {
    const client = new Client();
    const response = await client.post('/api/authenticate/master', 代行ログイントークン);
    const トークン: トークン型 = response.data;
    return トークン;
  },

  async refresh(リフレッシュトークン: string): Promise<string> {
    const client = new Client();
    const response = await client.post('/api/authenticate/token', {
      リフレッシュトークン,
    });
    const アクセストークン = response.data.アクセストークン;
    return アクセストークン;
  },

  async ログインアカウントを取得する(): Promise<ログインアカウント型> {
    const auth = new Auth();
    const response = await auth.get('/api/authenticate/user');
    const ログインアカウント = response.data;
    return ログインアカウント;
  },

  async 商品追加候補を検索する(商品追加候補検索条件: 商品追加候補検索条件型): Promise<商品追加検索結果一覧型> {
    const auth = new Auth();
    const response = await auth.post(`/api/purchaseorder/search/item`, 商品追加候補検索条件);
    const 商品追加検索結果一覧 = response.data;
    return 商品追加検索結果一覧;
  },

  async 定点発注を検索する(定点発注検索条件: 定点発注検索条件型): Promise<定点発注検索結果一覧型> {
    const auth = new Auth();
    const response = await auth.post(`/api/purchaseorder/search/demand`, 定点発注検索条件);
    const 定点発注検索結果一覧 = response.data;
    return 定点発注検索結果一覧;
  },

  async 履歴追加候補を検索する(履歴追加候補検索条件: 履歴追加候補検索条件型): Promise<履歴追加検索結果一覧型> {
    const auth = new Auth();
    const response = await auth.post(`/api/purchaseorder/search/history`, 履歴追加候補検索条件);
    const 履歴追加検索結果一覧 = response.data;
    return 履歴追加検索結果一覧;
  },

  async ハンディPC発注一覧を取得する(ハンディPC発注取得依頼: ハンディPC発注取得依頼型): Promise<ハンディPC発注取得結果一覧型> {
    const auth = new Auth();
    const response = await auth.post(`/api/purchaseorder/handy/orderlist`, ハンディPC発注取得依頼);
    const ハンディPC発注取得結果一覧 = response.data;
    return ハンディPC発注取得結果一覧;
  },

  async ハンディPC発注を取り込む(ハンディPC発注取込: ハンディPC発注取込型): Promise<ハンディPC発注取込結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/purchaseorder/handy/retrieve`, ハンディPC発注取込);
    const ハンディPC発注取込結果: ハンディPC発注取込結果型 = response.data;
    return ハンディPC発注取込結果;
  },

  async HTデータ取込対象一覧を取得する(): Promise<HTデータ取込対象一覧取得結果型> {
    const auth = new Auth();
    const response = await auth.get(`/api/purchaseorder/handy/devicelist`);
    const 利用者一覧取得結果: HTデータ取込対象一覧取得結果型 = response.data;
    return 利用者一覧取得結果;
  },

  async コード入力候補を検索する(コード入力候補検索条件: コード入力候補検索条件型): Promise<コード入力検索結果一覧型> {
    const auth = new Auth();
    const response = await auth.post(`/api/purchaseorder/search/code`, コード入力候補検索条件);
    const コード入力検索結果一覧 = response.data;
    return コード入力検索結果一覧;
  },

  async 優先卸を変更する(優先卸変更依頼: 優先卸変更依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post(`/api/wholesale/change/primary`, 優先卸変更依頼);
    return;
  },

  async 発注を確定送信する(発注確定送信リスト: 発注確定送信型): Promise<発注確定送信結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/purchaseorder/fixed`, 発注確定送信リスト);
    const 発注確定送信結果: 発注確定送信結果型 = response.data;
    return 発注確定送信結果;
  },

  async 発注候補商品を登録する(発注未確定登録リスト: 発注未確定登録型): Promise<発注未確定登録結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/purchaseorder/register`, 発注未確定登録リスト);
    const 発注未確定登録結果: 発注未確定登録結果型 = response.data;
    return 発注未確定登録結果;
  },

  async 発注未確定を保存する(発注未確定更新リスト: 発注未確定更新型): Promise<void> {
    const auth = new Auth();
    await auth.post(`/api/purchaseorder/update`, 発注未確定更新リスト);
    return;
  },

  async 発注未確定を削除する(発注未確定削除: 発注未確定削除依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post(`/api/purchaseorder/delete`, 発注未確定削除);
    return;
  },

  async 発注未確定一覧を取得する(発注未確定一覧取得依頼: 発注未確定一覧取得依頼型): Promise<発注未確定一覧取得結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/purchaseorder/list`, 発注未確定一覧取得依頼);
    const 発注未確定一覧取得結果: 発注未確定一覧取得結果型 = response.data;
    return 発注未確定一覧取得結果;
  },

  async 過去発注情報を取得する(商品コード: string): Promise<過去発注情報取得結果型> {
    const auth = new Auth();
    const response = await auth.get('/api/purchaseorder/past/' + 商品コード);
    return response.data;
  },

  async 発注履歴を検索する(発注履歴照会依頼: 発注履歴照会依頼型): Promise<発注履歴照会結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/purchaseorder/history/search`, 発注履歴照会依頼);
    const 発注履歴照会結果 = response.data;
    return 発注履歴照会結果;
  },

  async 非稼働日を取得する(非稼働日一覧取得依頼: 非稼働日一覧取得依頼型): Promise<非稼働日一覧取得結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/calendar/nonoperation`, 非稼働日一覧取得依頼);
    const 非稼働日一覧 = response.data;
    return 非稼働日一覧;
  },

  async 定点発注条件設定一覧を取得する(定点発注条件設定取得依頼: 定点発注条件設定取得依頼型): Promise<定点発注条件設定取得結果一覧型> {
    const auth = new Auth();
    const response = await auth.post('/api/purchaseorder/demand/list', 定点発注条件設定取得依頼);
    const 定点発注条件設定取得結果一覧: 定点発注条件設定取得結果一覧型 = response.data;
    return 定点発注条件設定取得結果一覧;
  },

  async 定点発注条件設定を更新する(定点発注条件設定更新依頼: 定点発注条件設定更新依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/purchaseorder/demand/update', 定点発注条件設定更新依頼);
    return;
  },

  async 定点発注条件設定のExcel取込をする(params: FormData): Promise<定点発注条件設定取込不可一覧型> {
    const auth = new Auth();
    const response = await auth.post('/api/purchaseorder/demand/import', params, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
    const 定点発注条件設定取込不可一覧: 定点発注条件設定取込不可一覧型 = response.data;
    return 定点発注条件設定取込不可一覧;
  },

  async バーコードブックExcelを取込する(params: FormData): Promise<バーコードブック取込結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/report/print/barcodebook/import', params, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
    const バーコードブック取込結果: バーコードブック取込結果型 = response.data;
    return バーコードブック取込結果;
  },

  async 入庫履歴を検索する(入庫履歴照会依頼: 入庫履歴照会依頼型): Promise<入庫履歴照会結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/stock/receive/history/search`, 入庫履歴照会依頼);
    const 入庫履歴照会結果 = response.data;
    return 入庫履歴照会結果;
  },

  async 返品履歴を検索する(返品履歴照会依頼: 返品履歴照会依頼型): Promise<返品履歴照会型[]> {
    const auth = new Auth();
    const response = await auth.post(`/api/stock/returns/history/search`, 返品履歴照会依頼);
    const 返品履歴一覧 = response.data;
    return 返品履歴一覧;
  },

  async 納品データ受信を指示する(): Promise<void> {
    const auth = new Auth();
    await auth.post(`/api/stock/deliverydata`);
  },

  async 納品データ受信を検索する(納品データ受信依頼: 納品データ受信依頼型): Promise<納品データ受信型[]> {
    const auth = new Auth();
    const response = await auth.post(`/api/stock/deliverydata/search`, 納品データ受信依頼);
    const 納品データ受信一覧 = response.data.納品データ受信一覧;
    return 納品データ受信一覧;
  },

  async 納品依頼を検索する(納品データ受信依頼: 納品データ受信依頼型): Promise<納品データ受信結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/stock/deliverydata/search`, 納品データ受信依頼);
    const 納品データ受信結果 = response.data;
    return 納品データ受信結果;
  },

  async 納品伝票一覧を取得する(納品番号: number): Promise<納品伝票型[]> {
    const auth = new Auth();
    const response = await auth.get(`/api/stock/deliverydata/${納品番号}`);
    const 納品伝票一覧 = response.data.納品伝票一覧;
    return 納品伝票一覧;
  },

  async 納品伝票明細一覧を取得する(取得依頼: 納品伝票明細一覧取得依頼型): Promise<納品伝票明細型[]> {
    const auth = new Auth();
    const response = await auth.post(`/api/stock/deliverydata/detail/list`, 取得依頼);
    const 納品伝票明細一覧 = response.data.納品伝票明細一覧;
    return 納品伝票明細一覧;
  },

  async 未入庫納品伝票を検索する(納品データ検索依頼: 納品データ検索依頼型): Promise<未入庫納品データ検索結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/stock/unstocked_deliverydata/search`, 納品データ検索依頼);
    const 未入庫納品データ検索結果 = response.data;
    return 未入庫納品データ検索結果;
  },

  async 棚卸差数在庫場所一覧を取得する(): Promise<棚卸差数在庫場所結果型> {
    const auth = new Auth();
    const response = await auth.get('/api/inquire/inventory_diff/inventory_location');
    const 在庫場所一覧 = response.data;
    return 在庫場所一覧;
  },

  async 棚卸差数棚卸年月日一覧を取得する(部署コード: string): Promise<棚卸差数棚卸年月日型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/inquire/inventory_diff/inventory_date/' + 部署コード);
    const 棚卸年月日一覧 = response.data;
    return 棚卸年月日一覧;
  },

  async 棚卸差数一覧を取得する(棚卸差数検索依頼: 棚卸差数検索依頼型): Promise<棚卸差数結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/inquire/inventory_diff', 棚卸差数検索依頼);
    const 棚卸差数一覧 = response.data;
    return 棚卸差数一覧;
  },

  async 採用品マスタ一覧を検索する(採用品検索条件: 採用品検索条件型): Promise<採用品検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/item/list', 採用品検索条件);
    const 採用品一覧 = response.data;
    return 採用品一覧;
  },

  async 採用品マスタを取得する(商品コード: string): Promise<採用品型> {
    const auth = new Auth();
    const response = await auth.get('/api/item/' + 商品コード);
    const 採用品 = response.data;
    return 採用品;
  },

  async JANコードで採用品マスタを取得する(JANコード: string): Promise<採用品型> {
    const auth = new Auth();
    const response = await auth.get('/api/item/byjan/' + JANコード);
    const 採用品 = response.data;
    return 採用品;
  },

  async 採用品拡張項目を取得する(商品コード: string): Promise<採用品拡張項目型> {
    const auth = new Auth();
    const response = await auth.get('/api/item/extendfield/' + 商品コード);
    const 採用品拡張項目 = response.data;
    return 採用品拡張項目;
  },

  async 採用品マスタを削除する(商品コード: string, 管理対象外依頼: 採用品管理対象外識別子型): Promise<void> {
    // NOTE: deleteメソッド時のrequestbodyはdataをつける
    const auth = new Auth();
    await auth.delete('/api/item/' + 商品コード, {data: 管理対象外依頼});
    return;
  },

  async 採用品データを包括的に取得する(商品コード: string): Promise<採用品包括型> {
    const auth = new Auth();
    const response = await auth.get('/api/item/' + 商品コード + '/detail');
    const 採用品 = response.data;
    return 採用品;
  },

  async 初期卸を取得する(): Promise<初期卸型> {
    const auth = new Auth();
    const response = await auth.get('/api/item/wholesale/startup');
    const 初期卸 = response.data  ;
    return 初期卸;
  },

  async 商品卸一覧を取得する(): Promise<商品卸型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/item/wholesale');
    const 商品卸一覧 = response.data;
    return 商品卸一覧;
  },

  async 価格履歴一覧を取得する(商品コード: string, 卸コード: string): Promise<価格履歴型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/item/' + 商品コード + '/' + 卸コード + '/price');
    const 価格履歴一覧 = response.data;
    return 価格履歴一覧;
  },

  async 薬効を取得する(薬効分類コード: string): Promise<薬効型> {
    const auth = new Auth();
    const response = await auth.get('/api/item/effect/' + 薬効分類コード);
    const 薬効 = response.data;
    return 薬効;
  },

  async JANコード重複採用品を取得する(JANコード: string): Promise<採用品型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/item/jan/' + JANコード);
    return response.data;
  },

  async 医薬品を取得する(JANコード: string): Promise<医薬品型> {
    const auth = new Auth();
    const response = await auth.get('/api/item/medicine/' + JANコード);
    const 医薬品 = response.data;
    return 医薬品;
  },

  async 医薬品一覧を検索する(医薬品検索条件: 医薬品検索条件型): Promise<医薬品検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/item/medicine/list', 医薬品検索条件);
    const 医薬品一覧 = response.data;
    return 医薬品一覧;
  },

  async 医薬品を登録する(医薬品登録情報: 採用品型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/item/medicine', 医薬品登録情報);
    return;
  },

  async 医薬品を更新する(医薬品更新情報: 採用品型): Promise<void> {
    const auth = new Auth();
    await auth.put('/api/item/medicine/' + 医薬品更新情報.商品コード, 医薬品更新情報);
    return;
  },

  async メーカー一覧を検索する(メーカー検索条件: メーカー検索条件型): Promise<メーカー検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/item/maker/list', メーカー検索条件);
    const メーカー一覧 = response.data;
    return メーカー一覧;
  },

  async その他品を取得する(JANコード: string): Promise<その他品型> {
    const auth = new Auth();
    const response = await auth.get('/api/item/other/' + JANコード);
    const その他品 = response.data;
    return その他品;
  },

  async その他品一覧を検索する(その他品検索条件: any): Promise<その他品検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/item/other/list', その他品検索条件);
    const その他品一覧 = response.data;
    return その他品一覧;
  },

  async その他品を登録する(その他品登録情報: 採用品型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/item/other', その他品登録情報);
    return;
  },

  async その他品を更新する(その他品更新情報: any): Promise<void> {
    const auth = new Auth();
    await auth.put('/api/item/other/' + その他品更新情報.商品コード, その他品更新情報);
    return;
  },

  async その他品関連データ件数を取得する(商品コード: string): Promise<number> {
    const auth = new Auth();
    const response = await auth.get('/api/item/other/relation/count/' + 商品コード);
    return response.data;
  },

  async 備蓄品を取得する(JANコード: string): Promise<備蓄品型> {
    const auth = new Auth();
    const response = await auth.get('/api/item/stockpile/' + JANコード);
    const 備蓄品 = response.data;
    return 備蓄品;
  },

  async 備蓄品一覧を検索する(備蓄品検索条件: any): Promise<備蓄品検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/item/stockpile/list', 備蓄品検索条件);
    const 備蓄品一覧 = response.data;
    return 備蓄品一覧;
  },

  async 備蓄品を登録する(備蓄品登録情報: 採用品型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/item/stockpile', 備蓄品登録情報);
    return;
  },

  async 備蓄品を更新する(備蓄品更新情報: any): Promise<void> {
    const auth = new Auth();
    await auth.put('/api/item/stockpile/' + 備蓄品更新情報.商品コード, 備蓄品更新情報);
    return;
  },

  async 採用品一括登録用一覧を検索する(採用品検索条件: 採用品検索条件型): Promise<採用品検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/item/bulkregister/list', 採用品検索条件);
    const 採用品一覧 = response.data;
    return 採用品一覧;
  },

  async 採用品一括登録Excelを取り込む(アップロードデータ: FormData): Promise<any> {
    const auth = new Auth();
    const response = await auth.post('/api/item/bulkregister/import', アップロードデータ, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async 商品別連携設定を検索する(検索条件: 商品別連携設定検索条件型): Promise<商品別連携設定検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/item/external/list', 検索条件);
    return response.data;
  },

  async 商品別連携設定一括登録Excelを取り込む(アップロードデータ: FormData): Promise<商品別連携設定一括登録結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/item/external/bulkregister/import', アップロードデータ, {
        headers: {
            'content-type': 'multipart/form-data',
        },
    });
    return response.data;
  },

  async 商品別連携設定を登録する(商品別連携設定登録情報: 商品別連携設定登録型): Promise<商品別連携設定一括登録結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/item/external/bulkregister', 商品別連携設定登録情報);
    return response.data;
  },

  async 採用品出力設定を取得する(): Promise<採用品Excel出力設定型> {
    const auth = new Auth();
    const response = await auth.get('/api/item/export/config');
    return response.data;
  },

  async 採用品出力設定を登録する(採用品出力設定: 採用品Excel出力設定型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/item/export/config', 採用品出力設定);
    return;
  },

  async 入札を取込する(): Promise<入札取込結果型> {
    const auth = new Auth();
    const response = await auth.get('/api/estimates/retrospective/bid');
    return {...response.data};
  },

  async 入札情報を同期する(): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/estimates/comparison/item/sync');
  },

  async 入札商品を検索する(入札商品検索条件: 入札商品検索条件型): Promise<入札商品検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/estimates/comparison/item', 入札商品検索条件);
    const 入札商品検索結果 = response.data;
    return 入札商品検索結果;
  },

  async 未確定入札商品一覧を取得する(未確定入札取得依頼: 未確定入札取得依頼型): Promise<卸比較商品型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/estimates/comparison/bid/unfixed', 未確定入札取得依頼);
    const 商品一覧 = response.data.商品一覧;
    return 商品一覧;
  },

  async 入札を開始する(入札開始依頼: 入札開始依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/estimates/comparison/bid/start', 入札開始依頼);
  },

  async 入札を確定する(入札確定依頼: 入札確定依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/estimates/comparison/fixed/register', 入札確定依頼);
  },

  async 卸比較優先卸を最低値に変更する(卸比較優先卸変更依頼: 卸比較優先卸変更依頼型): Promise<卸比較優先卸変更結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/estimates/comparison/wholesale/update/min', 卸比較優先卸変更依頼);
    const 卸比較優先卸変更結果 = response.data;
    return 卸比較優先卸変更結果;
  },

  async 卸比較優先卸を現納入卸に変更する(卸比較優先卸変更依頼: 卸比較優先卸変更依頼型): Promise<卸比較優先卸変更結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/estimates/comparison/wholesale/update/now', 卸比較優先卸変更依頼);
    const 卸比較優先卸変更結果 = response.data;
    return 卸比較優先卸変更結果;
  },

  async 未確定入札を削除する(未確定入札削除依頼: 未確定入札削除依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/estimates/comparison/bid/unfixed/clear', 未確定入札削除依頼);
  },

  async 確定入札を削除する(確定済入札削除依頼: 確定済入札削除依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/estimates/comparison/bid/fixed/clear', 確定済入札削除依頼);
  },

  async 入札額を更新する(入札額変更依頼: 入札額変更依頼型): Promise<卸比較商品型> {
    const auth = new Auth();
    const response = await auth.post('/api/estimates/comparison/bid/price/change', 入札額変更依頼);
    const 卸比較商品: 卸比較商品型 = response.data.卸比較商品;
    return 卸比較商品;
  },

  async 最新の入札を取得する(): Promise<入札型> {
    const auth = new Auth();
    const response = await auth.get('/api/estimates/bid/latest');
    return response.data;
  },

  async 遡及を検索する(遡及検索条件: 遡及検索条件型): Promise<遡及検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/estimates/retrospective/search', 遡及検索条件);
    const 遡及検索結果 = response.data;
    return 遡及検索結果;
  },

  async 優先卸個別変更する(優先卸個別変更依頼: 優先卸個別変更依頼型): Promise<卸比較商品型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/estimates/comparison/wholesale/update/single', 優先卸個別変更依頼);
    const 商品一覧: 卸比較商品型[] = response.data.商品一覧;
    return 商品一覧;
  },

  async 遡及訂正登録する(遡及訂正登録依頼: 遡及訂正登録依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/estimates/retrospective', 遡及訂正登録依頼);
  },

  async 未確定入札Excelを取込する(params: FormData): Promise<入札Excel取込結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/estimates/bid/import', params, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async 卸一覧を取得する(): Promise<卸型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/wholesale/list');
    const 卸一覧 = response.data;
    return 卸一覧;
  },

  async 削除を含む卸一覧を取得する(): Promise<卸型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/wholesale/list?all=true');
    const 卸一覧 = response.data;
    return 卸一覧;
  },

  async 卸を登録する(卸登録: 卸型): Promise<卸型> {
    const auth = new Auth();
    const response = await auth.post('/api/wholesale/', 卸登録);
    const 卸 = response.data;
    return 卸;
  },

  async 卸を更新する(卸更新: 卸型): Promise<卸型> {
    const auth = new Auth();
    const response = await auth.post('/api/wholesale/update', 卸更新);
    const 卸 = response.data;
    return 卸;
  },

  async 卸を削除する(卸削除: 卸型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/wholesale/delete', {卸コード: 卸削除.卸コード, 更新バージョン: 卸削除.更新バージョン});
  },

  async EOS卸一覧を取得する(): Promise<EOS卸型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/wholesale/list/eos');
    const EOS卸一覧 = response.data;
    return EOS卸一覧;
  },

  async 部署一覧を取得する(): Promise<部署型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/department/list');
    const 部署一覧 = response.data;
    return 部署一覧;
  },

  async 削除を含む部署一覧を取得する(): Promise<部署型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/department/list?all=true');
    const 部署一覧 = response.data;
    return 部署一覧;
  },

  async 部署を登録する(部署登録: 部署型): Promise<部署型> {
    const auth = new Auth();
    const response = await auth.post('/api/department/', 部署登録);
    const 部署 = response.data;
    return 部署;
  },

  async 部署を更新する(部署更新: 部署型): Promise<部署型> {
    const auth = new Auth();
    const response = await auth.post('/api/department/update', 部署更新);
    const 部署 = response.data;
    return 部署;
  },

  async 部署を削除する(部署削除: 部署型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/department/delete', {部署コード: 部署削除.部署コード, 更新バージョン: 部署削除.更新バージョン});
  },

  async 譲渡譲受医療機関一覧を取得する(): Promise<譲渡譲受医療機関型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/transfermedical/list?target=削除含まない');
    const 譲渡譲受医療機関一覧 = response.data;
    return 譲渡譲受医療機関一覧;
  },

  async 削除を含む譲渡譲受医療機関一覧を取得する(): Promise<譲渡譲受医療機関型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/transfermedical/list?target=削除含む');
    const 譲渡譲受医療機関一覧 = response.data;
    return 譲渡譲受医療機関一覧;
  },

  async 削除を含む利用者一覧を取得する(): Promise<利用者型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/user/list?all=true');
    const 利用者一覧 = response.data;
    return 利用者一覧;
  },

  async 利用者一覧を取得する(): Promise<利用者型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/user/list');
    const 利用者一覧 = response.data;
    return 利用者一覧;
  },

  async 利用者を登録する(利用者登録: 利用者型): Promise<利用者型> {
    const auth = new Auth();
    const response = await auth.post('/api/user/', 利用者登録);
    const 利用者 = response.data;
    return 利用者;
  },

  async 利用者を更新する(利用者更新: 利用者型): Promise<利用者型> {
    const auth = new Auth();
    const response = await auth.post('/api/user/update', 利用者更新);
    const 利用者 = response.data;
    return 利用者;
  },

  async 利用者を削除する(利用者削除: 利用者型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/user/delete', {利用者コード: 利用者削除.利用者コード, 更新バージョン: 利用者削除.更新バージョン});
  },

  async 発注状況一覧を取得する(発注状況一覧取得依頼: 発注状況一覧取得依頼型): Promise<発注状況一覧取得結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/purchaseorder/status/list`, 発注状況一覧取得依頼);
    const 発注状況一覧取得結果 = response.data;
    return 発注状況一覧取得結果;
  },

  async 発注状況を更新する(発注状況更新依頼: 発注状況更新依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/purchaseorder/status/update', 発注状況更新依頼);
  },

  async 確定送信者一覧を取得する(): Promise<確定送信者型[]> {
    const auth = new Auth();
    const response = await auth.get(`/api/user/sender/list`);
    const 確定送信者一覧 = response.data;
    return 確定送信者一覧;
  },

  async ハンディを含む確定送信者一覧を取得する(): Promise<確定送信者型[]> {
    const auth = new Auth();
    const response = await auth.get(`/api/user/sender/list`, {params: {containsHandyTerminal: true}});
    const 確定送信者一覧 = response.data;
    return 確定送信者一覧;
  },

  async 入庫返品薬価差を集計する(入庫返品薬価差集計依頼: 入庫返品薬価差集計依頼型): Promise<入庫返品薬価差集計結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/stock/price_diff`, 入庫返品薬価差集計依頼);
    const 入庫返品薬価差集計結果 = response.data;
    return 入庫返品薬価差集計結果;
  },

  async 棚番設定を取得する(棚番設定表示条件: 棚番設定表示条件型): Promise<棚番設定一覧取得結果返却型> {
    const auth = new Auth();
    const response = await auth.post('/api/shelf/list', 棚番設定表示条件);
    const 棚番設定一覧取得結果 = response.data;
    return 棚番設定一覧取得結果;
  },

  async 棚番設定を更新する(棚番設定更新: 棚番設定更新型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/shelf/update', 棚番設定更新);
    return;
  },

  async 棚番設定のExcel取込をする(params: FormData): Promise<棚番設定取込不可一覧型> {
    const auth = new Auth();
    const response = await auth.post('/api/shelf/import', params, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
    const 棚番設定取込不可一覧: 棚番設定取込不可一覧型 = response.data;
    return 棚番設定取込不可一覧;
  },

  async カスタマイズ棚番設定を取得する(棚番設定表示条件: カスタマイズ棚番設定表示条件型): Promise<カスタマイズ棚番設定取得結果一覧型> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/goryoukaku/shelf/list', 棚番設定表示条件);
    const 棚番設定一覧 = response.data;
    return 棚番設定一覧;
  },

  async カスタマイズ棚番設定を更新する(棚番設定更新: カスタマイズ棚番設定更新型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/custom/goryoukaku/shelf/update', 棚番設定更新);
    return;
  },

  async カスタマイズ棚番設定を削除する(棚番設定削除: カスタマイズ棚番設定削除依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/custom/goryoukaku/shelf/delete', 棚番設定削除);
    return;
  },

  async カスタマイズ棚番設定のExcel取込をする(params: FormData): Promise<カスタマイズ棚番設定取込不可一覧型> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/goryoukaku/shelf/import', params, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
    const 棚番設定取込不可一覧: カスタマイズ棚番設定取込不可一覧型 = response.data;
    return 棚番設定取込不可一覧;
  },

  async 入庫候補商品を検索する(入庫候補検索条件: 入庫候補検索条件型): Promise<入庫候補検索結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/receive/item/search`, 入庫候補検索条件);
    const 入庫候補検索結果 = response.data;
    return 入庫候補検索結果;
  },

  async 入庫候補発注を検索する(入庫候補発注検索条件: 入庫候補発注検索条件型): Promise<入庫候補発注検索結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/receive/order/search`, 入庫候補発注検索条件);
    const 入庫候補発注検索結果 = response.data;
    return 入庫候補発注検索結果;
  },

  async コード入力入庫候補商品を検索する(コード入力入庫候補検索条件: コード入力入庫候補検索条件型): Promise<コード入力入庫候補検索結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/receive/code/search`, コード入力入庫候補検索条件);
    const コード入力入庫候補検索結果 = response.data;
    return コード入力入庫候補検索結果;
  },

  async 返品候補在庫を検索する(返品候補在庫検索条件: 返品候補在庫検索条件型): Promise<返品候補在庫検索結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/returns/stock_search`, 返品候補在庫検索条件);
    const 返品候補在庫検索結果 = response.data;
    return 返品候補在庫検索結果;
  },

  async 返品候補入庫を検索する(返品候補入庫検索条件: 返品候補入庫検索条件型): Promise<返品候補入庫検索結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/returns/receive_search`, 返品候補入庫検索条件);
    const 返品候補入庫検索結果 = response.data;
    return 返品候補入庫検索結果;
  },

  async 優先卸を検索する(優先卸検索依頼: 優先卸検索依頼型): Promise<優先卸検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/wholesale/primary/search', 優先卸検索依頼);
    const 優先卸検索結果 = response.data;
    return 優先卸検索結果;
  },

  async 優先卸履歴一覧を取得する(商品コード: string): Promise<優先卸履歴型[]> {
    const auth = new Auth();
    const response = await auth.get(`/api/wholesale/primary/${商品コード}/history`);
    const 優先卸履歴一覧 = response.data;
    return 優先卸履歴一覧;
  },

  async 優先卸予約を登録する(優先卸予約登録依頼: 優先卸予約登録依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/wholesale/primary/reservation', 優先卸予約登録依頼);
  },

  async 優先卸を更新する(優先卸更新依頼: 優先卸更新依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/wholesale/primary/update', 優先卸更新依頼);
  },

  async 優先卸予約を削除する(優先卸予約削除依頼: 優先卸予約削除依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/wholesale/primary/reservation/delete', 優先卸予約削除依頼);
  },

  async 優先卸取込Excelを取込する(アップロードデータ: FormData): Promise<優先卸取込結果型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/wholesale/primary/import', アップロードデータ, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async 適用価格を検索する(適用価格検索依頼: 適用価格検索依頼型): Promise<適用価格検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/item/price/search', 適用価格検索依頼);
    const 適用価格検索結果 = response.data;
    return 適用価格検索結果;
  },

  async 適用価格履歴一覧を取得する(商品コード: string, 卸コード: string): Promise<適用価格履歴型[]> {
    const auth = new Auth();
    const response = await auth.get(`/api/item/${商品コード}/${卸コード}/price/history`);
    const 適用価格履歴一覧 = response.data;
    return 適用価格履歴一覧;
  },

  async 適用価格予約を登録する(適用価格予約登録依頼: 適用価格予約登録依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/item/price/reservation', 適用価格予約登録依頼);
  },

  async 適用価格を更新する(適用価格更新依頼: 適用価格更新依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/item/price/update', 適用価格更新依頼);
  },

  async 適用価格予約を削除する(適用価格予約削除依頼: 適用価格予約削除依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/item/price/reservation/delete', 適用価格予約削除依頼);
  },

  async 現在適用価格を登録する(現在適用価格登録依頼: 現在適用価格登録依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/item/price/register', 現在適用価格登録依頼);
  },

  async 適用価格取込Excelを取込する(アップロードデータ: FormData): Promise<適用価格取込結果型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/item/price/import', アップロードデータ, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async 遡及引当を検索する(遡及引当検索依頼: 遡及引当検索依頼型): Promise<遡及引当検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/estimates/retrospective/reserve/search', 遡及引当検索依頼);
    const 遡及引当検索結果 = response.data;
    return 遡及引当検索結果;
  },

  async 遡及引当履歴一覧を取得する(商品コード: string, 卸コード: string): Promise<遡及引当履歴型[]> {
    const auth = new Auth();
    const response = await auth.get(`/api/estimates/retrospective/${商品コード}/${卸コード}/reserve/history`);
    const 遡及引当履歴一覧 = response.data;
    return 遡及引当履歴一覧;
  },

  async 遡及引当を更新する(遡及引当更新依頼: 遡及引当更新依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/estimates/retrospective/reserve/update', 遡及引当更新依頼);
  },

  async 遡及引当を削除する(遡及引当削除依頼: 遡及引当削除依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/estimates/retrospective/reserve/delete', 遡及引当削除依頼);
  },

  async 在庫から返品を生成する(在庫指定返品作成依頼: 在庫指定返品作成依頼型): Promise<返品入力型[]> {
    const auth = new Auth();
    const response = await auth.post(`/api/stock/returns/create`, 在庫指定返品作成依頼);
    const 返品一覧 = response.data;
    return 返品一覧;
  },

  async 返品を更新する(返品修正依頼: 返品修正依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/returns/register/fixed', 返品修正依頼);
  },

  async 返品を検索する(検索条件: 確定済返品検索条件型): Promise<確定済返品検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/returns/search', 検索条件);
    const 確定済返品検索結果 = response.data;
    return 確定済返品検索結果;
  },

  async 確定済返品を削除する(返品削除レコード: 返品修正削除レコード型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/returns/delete/fixed', 返品削除レコード);
  },

  async 入庫を検索する(検索条件: 確定済在庫検索条件型): Promise<確定済在庫検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/receive/search', 検索条件);
    const 確定済在庫検索結果 = response.data;
    return 確定済在庫検索結果;
  },

  async 入庫を更新する(入庫修正依頼: 入庫修正削除依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/receive/register/fixed', 入庫修正依頼);
  },

  async 確定済入庫を削除する(入庫削除レコード: 入庫修正削除型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/receive/delete/fixed', 入庫削除レコード);
  },

  async ハンディ入庫を取り込む(ハンディ入庫取込依頼: ハンディ入庫取込依頼型): Promise<number[]> {
    const auth = new Auth();
    const response = await auth.post('/api/receive/handy/import', ハンディ入庫取込依頼);
    const 入庫SEQ一覧 = response.data;
    return 入庫SEQ一覧;
  },

  async 取込んだ未確入庫を取得する(未確定入庫一覧取得依頼: 未確定入庫一覧取得依頼型): Promise<入庫入力型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/receive/unsettled/list', 未確定入庫一覧取得依頼);
    const 入庫一覧 = response.data;
    return 入庫一覧;
  },

  async ハンディ入庫を検索する(検索条件: ハンディ入庫検索依頼型): Promise<ハンディ入庫レコード型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/receive/handy/search', 検索条件);
    const ハンディ入庫レコード一覧 = response.data;
    return ハンディ入庫レコード一覧;
  },

  async ハンディ返品を取り込む(ハンディ返品取込依頼: ハンディ返品取込依頼型): Promise<number[]> {
    const auth = new Auth();
    const response = await auth.post('/api/returns/handy/import', ハンディ返品取込依頼);
    const 返品SEQ一覧 = response.data;
    return 返品SEQ一覧;
  },

  async 未確定返品一覧取得(未確定返品一覧取得依頼: 未確定返品一覧取得依頼型): Promise<返品入力型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/returns/unsettled/list', 未確定返品一覧取得依頼);
    const 返品入力一覧 = response.data;
    return 返品入力一覧;
  },

  async ハンディ返品を検索する(検索条件: ハンディ返品検索依頼型): Promise<ハンディ返品レコード型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/returns/handy/search', 検索条件);
    const ハンディ返品レコード一覧 = response.data;
    return ハンディ返品レコード一覧;
  },

  async 商品から入庫を生成する(入庫作成依頼: 入庫作成依頼型): Promise<入庫入力型[]> {
    const auth = new Auth();
    const response = await auth.post(`/api/receive/create`, 入庫作成依頼);
    const 入庫一覧 = response.data;
    return 入庫一覧;
  },

  async 入庫から返品を生成する(入庫指定返品作成依頼: 入庫指定返品作成依頼型): Promise<返品入力型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/receive/returns/create', 入庫指定返品作成依頼);
    const 返品一覧 = response.data;
    return 返品一覧;
  },

  async 未確定返品を読み込む(未確定返品取込依頼: 未確定返品取込依頼型): Promise<返品入力型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/returns/unsettled', 未確定返品取込依頼);
    const 返品一覧 = response.data;
    return 返品一覧;
  },

  async 返品を確定する(返品確定依頼: 返品確定依頼型): Promise<any> {
    const auth = new Auth();
    const response = await auth.post('/api/returns/register/unfixed', 返品確定依頼);
    return response.data;
  },

  async 返品を保存する(返品確定依頼: 返品確定依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/returns/register/temporal', 返品確定依頼);
  },

  async 返品納品データを検索する(返品納品データ取込依頼: 返品納品データ取込依頼型): Promise<返品納品データ取込結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/returns/delivery', 返品納品データ取込依頼);
    const 返品納品データ取込結果 = response.data;
    return 返品納品データ取込結果;
  },

  async 未確定返品を削除する(返品削除レコード: 返品入力型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/returns/delete/unfixed', 返品削除レコード);
  },

  async 未確定入庫を読み込む(入庫取込依頼: 入庫取込依頼型): Promise<入庫入力型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/receive/unsettled', 入庫取込依頼);
    const 入庫一覧 = response.data;
    return 入庫一覧;
  },

  async 入庫納品データを検索する(入庫納品データ取込依頼: 入庫納品データ検索条件型): Promise<入庫納品データ検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/receive/delivery', 入庫納品データ取込依頼);
    const 入庫入力一覧 = response.data;
    return 入庫入力一覧;
  },

  async 発注指定入庫を確定する(入庫確定依頼: 発注指定入庫確定依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/receive/register/order/fix', 入庫確定依頼);
  },

  async 入庫を確定する(入庫確定依頼: 入庫確定依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/receive/register/unfixed', 入庫確定依頼);
  },

  async 入庫を保存する(入庫保存依頼: 入庫保存依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/receive/register/temporal', 入庫保存依頼);
  },

  async 未確定入庫を削除する(入庫削除レコード: 入庫入力型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/receive/delete/unfixed', 入庫削除レコード);
  },

  async 譲受候補商品を検索する(譲受候補商品検索条件: 譲受候補検索条件型): Promise<譲受候補検索結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/inherit/item/search`, 譲受候補商品検索条件);
    const 譲受候補検索結果 = response.data;
    return 譲受候補検索結果;
  },

  async 譲受候補を作成する(譲受候補作成依頼: 譲受候補作成依頼型): Promise<譲受候補入力型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/inherit/create', 譲受候補作成依頼);
    const 譲受候補一覧 = response.data;
    return 譲受候補一覧;
  },

  async 譲受金額を算出する(譲受金額算出依頼: 譲受金額算出依頼型): Promise<譲受金額算出結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/inherit/calculation', 譲受金額算出依頼);
    const 譲受金額算出結果 = response.data;
    return 譲受金額算出結果;
  },

  async 譲受を確定する(譲受確定依頼: 譲受確定依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/inherit/register', 譲受確定依頼);
  },

  async 譲受を検索する(検索条件: 譲受検索条件型): Promise<譲受修正検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/inherit/search', 検索条件);
    const 譲受修正一覧 = response.data;
    return 譲受修正一覧;
  },

  async 譲受を修正する(譲受修正依頼: 譲受修正依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/inherit/modification', 譲受修正依頼);
  },

  async 譲受を削除する(譲受削除依頼: 譲受削除依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/inherit/delete', 譲受削除依頼);
  },

  async 譲受履歴を検索する(検索条件: 譲受履歴検索条件型): Promise<譲受履歴検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/inherit/history/search', 検索条件);
    const 譲受履歴検索結果 = response.data;
    return 譲受履歴検索結果;
  },

  async 譲渡候補在庫を検索する(譲渡候補在庫検索条件: 譲渡候補在庫検索条件型): Promise<譲渡候補在庫検索結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/devolve/stock/search`, 譲渡候補在庫検索条件);
    const 譲渡候補在庫検索結果 = response.data;
    return 譲渡候補在庫検索結果;
  },

  async 在庫指定して譲渡候補を作成する(在庫指定譲渡候補作成依頼: 在庫指定譲渡候補作成依頼型): Promise<譲渡候補入力型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/devolve/stock/create', 在庫指定譲渡候補作成依頼);
    const 譲渡候補一覧 = response.data;
    return 譲渡候補一覧;
  },

  async 譲渡候補商品を検索する(譲渡候補商品検索条件: 譲渡候補商品検索条件型): Promise<譲渡候補商品検索結果型> {
    const auth = new Auth();
    const response = await auth.post(`/api/devolve/item/search`, 譲渡候補商品検索条件);
    const 譲渡候補商品検索結果 = response.data;
    return 譲渡候補商品検索結果;
  },

  async 商品指定して譲渡候補を作成する(譲渡候補作成依頼: 商品指定譲渡候補作成依頼型): Promise<譲渡候補入力型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/devolve/item/create', 譲渡候補作成依頼);
    const 譲渡候補一覧 = response.data;
    return 譲渡候補一覧;
  },

  async 譲渡確認消費税を取得する(): Promise<譲渡確認消費税型> {
    const auth = new Auth();
    const response = await auth.post('/api/devolve/tax');
    const 譲渡確認消費税 = response.data;
    return 譲渡確認消費税;
  },

  async 譲渡金額を算出する(譲渡金額算出依頼: 譲渡金額算出依頼型): Promise<譲渡金額算出結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/devolve/calculation', 譲渡金額算出依頼);
    const 譲渡金額算出結果 = response.data;
    return 譲渡金額算出結果;
  },

  async 譲渡を確定する(譲渡確定依頼: 譲渡確定依頼型): Promise<譲渡確定結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/devolve/register', 譲渡確定依頼);
    const 譲渡確定結果 = response.data;
    return 譲渡確定結果;
  },

  async 譲渡を検索する(検索条件: 譲渡検索条件型): Promise<譲渡修正検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/devolve/search', 検索条件);
    const 譲渡修正一覧 = response.data;
    return 譲渡修正一覧;
  },

  async 譲渡を削除する(譲渡削除依頼: 譲渡削除依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/devolve/delete', 譲渡削除依頼);
  },

  async 譲渡を修正する(譲渡修正依頼: 譲渡修正依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/devolve/modification', 譲渡修正依頼);
  },

  async 譲渡履歴を検索する(検索条件: 譲渡履歴検索条件型): Promise<譲渡履歴検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/devolve/history/search', 検索条件);
    const 譲渡履歴検索結果 = response.data;
    return 譲渡履歴検索結果;
  },

  async 破棄破損を登録する(破棄破損登録依頼: 破棄破損依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/destroy', 破棄破損登録依頼);
  },

  async 破棄破損商品を検索する(破棄破損候補検索条件: 破棄破損候補検索条件型): Promise<破棄破損候補検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/destroy/item/search', 破棄破損候補検索条件);
    return response.data;
  },

  async 破棄破損修正候補を検索する(破棄破損修正候補検索条件: 破棄破損修正候補検索条件型): Promise<破棄破損修正候補検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/destroy/modification/search', 破棄破損修正候補検索条件);
    return response.data;
  },

  async 破棄破損を削除する(破棄破損削除依頼: 破棄破損削除依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/destroy/modification/delete', 破棄破損削除依頼);
  },

  async 破棄破損を修正する(破棄破損修正依頼: 破棄破損修正依頼一覧型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/destroy/modification', 破棄破損修正依頼);
  },

  async 破棄破損履歴を検索する(破棄破損履歴検索条件: 破棄破損履歴検索条件型): Promise<破棄破損履歴検索結果返却型> {
    const auth = new Auth();
    const response = await auth.post('/api/destroy/reference', 破棄破損履歴検索条件);
    return response.data;
  },

  async 払出履歴を検索する(払出履歴検索条件: 払出履歴検索条件型): Promise<払出履歴検索結果返却型> {
    const auth = new Auth();
    const response = await auth.post('/api/withdrawal/reference', 払出履歴検索条件);
    return response.data;
  },

  async 払出を登録する(払出登録依頼: 払出依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/withdrawal', 払出登録依頼);
  },

  async 払出商品を検索する(検索条件: 払出候補検索条件型): Promise<払出候補検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/withdrawal/item/search', 検索条件);
    return response.data;
  },

  async 払出を削除する(払出削除依頼: 払出削除依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/withdrawal/modification/delete', 払出削除依頼);
  },

  async 払出を検索する(払出修正候補検索条件: 払出修正候補検索条件型): Promise<払出修正候補検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/withdrawal/modification/search', 払出修正候補検索条件);
    return response.data;
  },

  async 払出を修正する(払出修正: 払出修正依頼型[]): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/withdrawal/modification', {払出修正依頼一覧: 払出修正});
  },

  async 棚卸部署一覧を取得する(): Promise<棚卸部署型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/stocktaking/department');
    const 棚卸部署一覧 = response.data;
    return 棚卸部署一覧;
  },

  async 棚卸部署概要を取得する(棚卸部署コード: string): Promise<棚卸部署概要型> {
    const auth = new Auth();
    const response = await auth.get(`/api/stocktaking/department/${棚卸部署コード}`);
    const 棚卸部署概要 = response.data;
    return 棚卸部署概要;
  },

  async HT棚卸情報を取得する(棚卸番号: number): Promise<ハンディ棚卸情報型> {
    const auth = new Auth();
    const response = await auth.get(`/api/stocktaking/${棚卸番号}/handy`);
    const ハンディ棚卸情報 = response.data;
    return ハンディ棚卸情報;
  },

  async 棚卸を取得する(棚卸取得依頼: 棚卸取得依頼型): Promise<棚卸情報型> {
    const auth = new Auth();
    const response = await auth.get('/api/stocktaking', {params: 棚卸取得依頼});
    const 棚卸情報 = response.data;
    return 棚卸情報;
  },

  async 棚卸を絞り込む(棚卸絞込み依頼: 棚卸絞込み依頼型): Promise<棚卸情報型> {
    const auth = new Auth();
    const response = await auth.get('/api/stocktaking', {params: 棚卸絞込み依頼});
    const 棚卸情報 = response.data;
    return 棚卸情報;
  },

  async 棚卸を作成する(棚卸作成依頼: 棚卸作成依頼型): Promise<棚卸情報型> {
    const auth = new Auth();
    const response = await auth.post('/api/stocktaking', 棚卸作成依頼);
    const 取得済棚卸情報 = response.data;
    return 取得済棚卸情報;
  },

  async 棚卸を保存する(棚卸保存依頼: 棚卸保存依頼型): Promise<void> {
    const auth = new Auth();
    const 棚卸番号 = 棚卸保存依頼.棚卸番号;
    await auth.put(`/api/stocktaking/${棚卸番号}`, 棚卸保存依頼);
  },

  async 棚卸を確定する(棚卸番号: number, 棚卸確定依頼: 棚卸確定依頼型): Promise<void> {
    const auth = new Auth();
    await auth.put(`/api/stocktaking/${棚卸番号}/fix`, 棚卸確定依頼);
  },

  async 棚卸を取り消す(棚卸番号: number): Promise<void> {
    const auth = new Auth();
    await auth.delete(`/api/stocktaking/${棚卸番号}`);
  },

  async HT棚卸情報を取り込む(棚卸番号: number): Promise<void> {
    const auth = new Auth();
    await auth.post(`/api/stocktaking/${棚卸番号}/handy/import`);
  },

  async 棚卸を再計算する(棚卸番号: number, 棚卸再計算依頼: 棚卸再計算依頼型): Promise<void> {
    const auth = new Auth();
    await auth.put(`/api/stocktaking/${棚卸番号}/recalculate`, 棚卸再計算依頼);
  },

  async 棚卸部署確定取消候補を取得する(棚卸部署コード: string): Promise<棚卸部署確定取消候補型> {
    const auth = new Auth();
    const response = await auth.get(`/api/stocktaking/department/${棚卸部署コード}/cancel`);
    const 棚卸部署確定取消候補 = response.data;
    return 棚卸部署確定取消候補;
  },

  async 棚卸確定取消する(棚卸番号: number): Promise<void> {
    const auth = new Auth();
    await auth.put(`/api/stocktaking/${棚卸番号}/fix/cancel`);
  },

  async 在庫照会の在庫場所一覧を取得する(): Promise<在庫場所型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/refstock/department');
    const 在庫場所一覧 = response.data.list;
    return 在庫場所一覧;
  },

  async 在庫を照会する(在庫照会検索条件: 在庫照会検索条件型): Promise<在庫照会結果型 | null> {
    const auth = new Auth();
    const response = await auth.post('/api/refstock', 在庫照会検索条件);
    const 在庫照会結果 = response.data;
    return 在庫照会結果;
  },

  async 卸別入出庫を集計する(卸別入出庫集計依頼: 卸別入出庫集計依頼型): Promise<卸別入出庫集計結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/summary/receive_delivery', 卸別入出庫集計依頼);
    const 卸別入出庫集計結果 = response.data;
    return 卸別入出庫集計結果;
  },

  async 品目別入出庫を集計する(品目別入出庫表示依頼: 品目別入出庫表示依頼型): Promise<品目別入出庫集計型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/summary/receive_delivery_item', 品目別入出庫表示依頼);
    const 集計結果一覧 = response.data.品目別入出庫集計結果一覧;
    return 集計結果一覧;
  },

  async 譲渡譲受医療機関を登録する(譲渡譲受医療機関登録依頼: 譲渡譲受医療機関登録依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/transfermedical/register', 譲渡譲受医療機関登録依頼);
  },

  async 譲渡譲受医療機関を削除する(譲渡譲受医療機関削除依頼: 譲渡譲受医療機関削除依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/transfermedical/delete', 譲渡譲受医療機関削除依頼);
  },

  async 譲渡譲受医療機関を更新する(更新対象譲渡譲受医療機関: 譲渡譲受医療機関型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/transfermedical/update', 更新対象譲渡譲受医療機関);
  },

  async 不動在庫を検索する(不動在庫検索依頼: 不動在庫検索依頼型): Promise<不動在庫検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/inactive/stock', 不動在庫検索依頼);
    const 検索結果一覧 = response.data.不動在庫照会結果一覧;
    return response.data;
  },

  async 商品台帳在庫場所一覧を取得する(): Promise<商品台帳在庫場所型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/stock/itemledger/department');
    const 商品台帳在庫場所一覧 = response.data;
    return 商品台帳在庫場所一覧;
  },

  async 商品台帳鏡情報を取得する(商品台帳鏡情報取得依頼: 商品台帳鏡情報取得依頼型): Promise<商品台帳鏡情報型> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/itemledger/header', 商品台帳鏡情報取得依頼);
    const 商品台帳鏡情報 = response.data;
    return 商品台帳鏡情報;
  },

  async 商品台帳明細内容を取得する(商品台帳明細内容取得依頼: 商品台帳明細内容取得依頼型): Promise<商品台帳明細内容型> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/itemledger/details', 商品台帳明細内容取得依頼);
    const 商品台帳明細内容 = response.data;
    return 商品台帳明細内容;
  },

  async マニュアル一覧を取得する(): Promise<マニュアル型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/manual/list');
    return response.data;
  },

  async 入出庫照会在庫場所一覧を取得する(): Promise<入出庫照会在庫場所型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/stock/receiveandreturns/department');
    const 入出庫照会在庫場所一覧 = response.data;
    return 入出庫照会在庫場所一覧;
  },

  async 入出庫を照会する(入出庫照会依頼: 入出庫照会依頼型): Promise<入出庫照会結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/receiveandreturns', 入出庫照会依頼);
    const 入出庫照会結果 = response.data;
    return 入出庫照会結果;
  },

  async 院内総在庫照会の在庫場所一覧を取得する(): Promise<院内総在庫場所型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/stock/inhospital/department');
    const 院内総在庫場所一覧 = response.data.list;
    return 院内総在庫場所一覧;
  },

  async 院内総在庫を照会する(院内総在庫照会検索条件: 院内総在庫照会検索条件型): Promise<院内総在庫照会結果型 | null> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/inhospital', 院内総在庫照会検索条件);
    const 院内総在庫照会結果 = response.data;
    return 院内総在庫照会結果;
  },

  async 経過措置照会の在庫場所一覧を取得する(): Promise<経過措置照会在庫場所型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/stock/interim/department');
    const 経過措置照会在庫場所一覧 = response.data.list;
    return 経過措置照会在庫場所一覧;
  },

  async 経過措置を照会する(経過措置照会検索条件: 経過措置照会検索条件型): Promise<経過措置照会結果型 | null> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/interim', 経過措置照会検索条件);
    const 経過措置照会結果 = response.data;
    return 経過措置照会結果;
  },

  async 不動日数設定一覧を取得する(不動日数設定取得依頼: 不動日数設定検索依頼型): Promise<不動日数設定型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/immovable/search', 不動日数設定取得依頼);
    return response.data;
  },

  async 不動日数設定を更新する(不動日数設定更新依頼: 不動日数設定更新依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post('/api/stock/immovable/update', 不動日数設定更新依頼);
    return;
  },

  async 不動日数設定のExcel取込をする(params: FormData): Promise<不動日数設定出力型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/stock/immovable/import', params, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async 医療機関グループ一覧を取得する(): Promise<医療機関グループ型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/medical/group/list');
    return response.data;
  },

  async 医療機関グループ詳細を検索する(検索依頼: 医療機関グループ詳細検索依頼型): Promise<医療機関グループ詳細検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/medical/group/search', 検索依頼);
    return response.data;
  },

  async 渓仁会納品データを検索する(検索依頼: 渓仁会納品データ検索依頼型): Promise<渓仁会納品データ検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/keijinkai/deliverydata/search', 検索依頼);
    return response.data;
  },

  async 渓仁会部署別在庫集計を検索する(検索依頼: 渓仁会部署別在庫集計検索依頼型): Promise<渓仁会部署別在庫集計検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/keijinkai/stock/total/search', 検索依頼);
    return response.data;
  },

  async 独自区分一覧を取得する(): Promise<独自区分型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/medical/customize/list');
    return response.data;
  },

  async 渓仁会入出庫集計を検索する(検索依頼: 渓仁会入出庫集計検索依頼型): Promise<渓仁会入出庫集計型> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/keijinkai/stock/receiveandreturns/search', 検索依頼);
    return response.data;
  },

  async 渓仁会部署別出庫実績集計を検索する(検索依頼: 渓仁会部署別出庫実績集計検索依頼型): Promise<渓仁会部署別出庫実績集計型[]> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/keijinkai/stock/shipment/search', 検索依頼);
    return response.data;
  },

  async 発注書を検索する(検索依頼: 発注書検索条件型): Promise<発注書検索結果型> {
    const auth = new Auth();
    const response = await auth.post('/api/report/print/purchaseorder/search', 検索依頼);
    return response.data;
  },

  async 新さっぽろ受払一覧表の在庫場所一覧を取得する(): Promise<部署型[]> {
    const auth = new Auth();
    const response = await auth.get('/api/shinsapporo/report/department');
    const 受払一覧場所一覧 = response.data.list;
    return 受払一覧場所一覧;
  },
};
